import React, { useEffect } from 'react';
import { connect } from 'react-redux';
// import { prop } from 'ramda';
import Routers from '@/router';

import { extractData, getSongAttributes } from '@/api';
import { setSongAttributes } from '@/store/actions/metadata/actions';
import styles from './app.module.css';
import Header from '@/components/Header';

const app = props => {
    const { setSongAttributes } = props;

    // fetch song attributes and save to redux
    useEffect(() => {
        const prepareAttributeData =  async () => {
          const res = await getSongAttributes();
          const data = extractData(res);
          setSongAttributes(data);
        };
        prepareAttributeData();

    }, []);

    return (
        <div className={ styles.Container }>
            <section className={ styles.Main }>
                <Header />
                <div className={ styles.Wrapper }>
                    <Routers />
                </div>
            </section>
        </div>
    );
};


const mapDispatchToProps = dispatch => ({
  setSongAttributes: songAttributes => dispatch(setSongAttributes(songAttributes))
});

export default connect(null, mapDispatchToProps)(app);
